/**
 * Created by sswaminathan on 1/9/23
 * File: BackBoneRegionModalBody
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Checkbox } from '@panwds/react-ui'
// import statement lib, local then scss or css
import { List, ListItem, Body, Bold, Link } from '@panwds/react-ui'
import { RedoIcon } from '@panwds/icons'
/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback, useEffect, useMemo, useState } from 'react'
import SearchInput from '../../../../../common/components/inputs/SearchInput'
import { APP_ID_BACKBONE } from '../../../../../common/constants/GlobalConstants'
import { RESET } from '../../../constants/SubscriptionConstant'
import BackBoneRegionCheckBox from './BackBoneRegionCheckBox'
import BackBoneRegionSelection from './BackBoneRegionSelection'

const BackBoneRegionModalBody = (props) => {
  const { apps } = props
  const regionList = useMemo(() => {
    return apps ? apps[APP_ID_BACKBONE]?.setup?.extra?.excluded_region_list ?? [] : []
  }, [apps])
  const { setExcludedRegionList, regionInformation } = props
  const [excludedRegion, setExcludedRegion] = useState([])
  const [allRegions, setAllRegions] = useState(false)
  const [regionMasterList, setRegionMasterList] = useState(regionList)
  const [indeterminate, setIndeterminate] = useState(false)
  useEffect(() => {
    const _regionSelected = regionInformation?.map((each) => each.toLowerCase())
    const filteredRegions = regionList?.filter((each) => {
      return _regionSelected.includes(each.region)
    })
    setExcludedRegion(filteredRegions)
  }, [apps, regionInformation, regionList])


  useEffect(() => {
    if (allRegions) {
      setIndeterminate(regionMasterList?.length !== excludedRegion?.length)
    }
    else {
      setIndeterminate(false)
    }

  }, [allRegions, excludedRegion?.length, regionMasterList?.length])

  const deleteExcludedList = useCallback((value) => {
    const filteredRegionList = excludedRegion.filter((each) => each.region !== value.region)
    setExcludedRegion([...filteredRegionList])
    setExcludedRegionList([...filteredRegionList])
  }, [excludedRegion, setExcludedRegionList])

  const insertExcludedList = useCallback((value, checked) => {
    if (!checked) {
      setExcludedRegion([...excludedRegion, value])
      setExcludedRegionList([...excludedRegion, value])
    }
    else {
      deleteExcludedList(value)
    }
  }, [deleteExcludedList, excludedRegion, setExcludedRegionList])


  const resetExcludedList = useCallback(() => {
    setExcludedRegion([])
    setExcludedRegionList([])
    setAllRegions(false)
  }, [setExcludedRegionList])

  const updateAllRegions = useCallback((value) => {
    if (!value) {
      resetExcludedList()
    }
    else {
      setExcludedRegion([...regionList])
      setExcludedRegionList([...regionList])
    }
  }, [regionList, resetExcludedList, setExcludedRegionList])


  const filterSearchResult = useCallback((value) => {
    if (value && value.length > 1) {
      const filterList = regionList.filter((each) => {
        return each?.region.toLowerCase().indexOf(value.toLowerCase()) >= 0
      })
      setRegionMasterList(filterList)
    }
    else {
      setRegionMasterList([...regionList])
    }

  }, [regionList])

  return <div className='tw-flex tw-flex-row'>
    <div className='tw-flex tw-flex-col tw-flex-1'>
      <div className='tw-py-2 tw-bg-gray-200 tw-px-2 tw-border-gray-300' style={{ borderRight: '1px solid', borderColor: '#DADBDB' }}>
        <SearchInput
          placeholder={'Search tags and apps'}
          addClassName='tw-flex-1'
          onChange={event => filterSearchResult(event.target.value)}
        />
        <div className='tw-mt-3 tw-pl-2'>
          <Checkbox
            checked={allRegions}
            indeterminate={indeterminate}
            onChange={
              () => {
                setAllRegions(!allRegions)
                updateAllRegions(!allRegions)
              }
            }>
            <Body size='sm'><Bold>All regions</Bold></Body>
          </Checkbox>
        </div>
      </div>
      <List style={{ maxHeight: '100%' }}>
        {regionMasterList?.map((each, index) => {
          const isRegionPresent = excludedRegion.find((elem) => elem.region === each.region)
          return <ListItem key={index}><BackBoneRegionCheckBox
            {...{
              value: each,
              callback: insertExcludedList,
              excludedRegion,
              isRegionPresent: !!isRegionPresent
            }}
          />
          </ListItem>
        })
        }
      </List>
    </div>
    <div className='tw-flex tw-flex-col tw-flex-1'>
      <div className='tw-flex tw-pl-1 tw-pt-5 tw-pb-11 tw-bg-gray-200'>
        <div className='tw-flex-1 tw-align-right'>
          <Body size='sm'><Bold> {`Region Exception (${excludedRegion?.length})`}</Bold></Body>
        </div>
        <div className='tw-align-right tw-pr-2'>
          <Link size='sm' onClick={resetExcludedList}>{RESET}
            <RedoIcon size='xs' className='tw-ml-1' />
          </Link>
        </div>
      </div>
      <List style={{ maxHeight: '100%' }}>
        {excludedRegion?.map((each, index) => {
          return <ListItem key={index}>
            <BackBoneRegionSelection
              callback={deleteExcludedList}
              value={each}/>
          </ListItem>
        })
        }
      </List>
    </div>
  </div>
}

BackBoneRegionModalBody.propTypes = {}
export default BackBoneRegionModalBody
